import { LucideIcon } from 'lucide-react';
import GlowCard from './GlowCard';

interface ComingSoonProps {
  icon: LucideIcon;
  title: string;
  note?: string;
}

/** Styled placeholder for Verity sections not yet reproduced in this pass. */
const ComingSoon = ({ icon: Icon, title, note }: ComingSoonProps) => (
  <div className="vr-page">
    <GlowCard hover={false}>
      <div className="vr-soon">
        <div className="vr-soon-icon">
          <Icon size={28} />
        </div>
        <h2 className="vr-h-sec">{title}</h2>
        <p className="vr-muted" style={{ maxWidth: 460 }}>
          {note || 'This section is part of the IQ Verity layout and will be reproduced in a following pass. The look, theme, and shell are already in place.'}
        </p>
        <span className="vr-chip">Reproduction in progress</span>
      </div>
    </GlowCard>
  </div>
);

export default ComingSoon;
